export default "__VITE_ASSET__CKNFwGCJ__"